import { render } from "./BaseFrontItem.vue?vue&type=template&id=0cb08d64&scoped=true"
import script from "./BaseFrontItem.vue?vue&type=script&lang=js"
export * from "./BaseFrontItem.vue?vue&type=script&lang=js"

import "./BaseFrontItem.vue?vue&type=style&index=0&id=0cb08d64&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb08d64"]])

export default __exports__